import { useCallback, useEffect, useMemo, useState } from "react";
import Multiselect from "multiselect-react-dropdown";
import { Button, Form, Modal } from "react-bootstrap";
import { groupAndProjectServices } from "../../../APIServices/WorkBridge/TeamManagement/groupAndProjectServices";
import { setGroupMembers } from "../../../APIServices/GoApiServices/chatService";

function uniqStrings(list) {
  const out = [];
  const seen = new Set();
  for (const x of list || []) {
    const v = String(x ?? "").trim();
    if (!v || seen.has(v)) continue;
    seen.add(v);
    out.push(v);
  }
  return out;
}

function toId(value) {
  if (!value) return "";
  if (typeof value === "string" || typeof value === "number") return String(value).trim();
  if (typeof value === "object") {
    return String(value.value ?? value.userId ?? value.id ?? "").trim();
  }
  return "";
}

function normalizeSelectedValues(rawAssigned, options) {
  const opts = Array.isArray(options) ? options : [];
  const byId = new Map(opts.map((o) => [String(o?.value ?? "").trim(), o]));

  const out = [];
  for (const item of rawAssigned || []) {
    const id = toId(item);
    if (!id) continue;

    if (typeof item === "object" && item?.label && item?.value) {
      out.push({ label: String(item.label), value: String(item.value) });
      continue;
    }

    const opt = byId.get(id);
    if (opt) out.push(opt);
    else out.push({ label: id, value: id });
  }
  return out;
}

const AddMemberInGroup = ({ show, hide, title, memberList, activeChannel, currentUserData }) => {
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [members, setMembers] = useState([]);

  const chatToken = useMemo(() => {
    return (
      currentUserData?.token ||
      currentUserData?.accessToken ||
      currentUserData?.authToken ||
      localStorage.getItem("token") ||
      ""
    );
  }, [currentUserData]);

  useEffect(() => {
    const mapped =
      memberList?.map((item) => ({
        label: item?.name,
        value: item?.userId,
      })) || [];
    setMembers(mapped);
  }, [memberList]);

  const handleChange = useCallback((selectedList) => {
    setSelectedMembers(Array.isArray(selectedList) ? selectedList : []);
  }, []);

  const getSingleGroupAndProject = useCallback(async () => {
    const gpId = activeChannel?.gpId;
    if (!gpId) return;

    const data = await groupAndProjectServices.getSingleGroupAndProject(gpId);
    const assigned = data?.data?.assignedUser || [];
    setSelectedMembers(normalizeSelectedValues(assigned, members));
  }, [activeChannel?.gpId, members]);

  const updatedGroupAndProject = useCallback(async () => {
    const gpId = activeChannel?.gpId;
    if (!gpId) return;

    const userData = {
      gpId,
      assignedType: true,
      assignedUser: selectedMembers?.map(item => item.value),
    };

    const data = await groupAndProjectServices.updatedGroupAndProject(userData);

    if (data?.statusCode === 200) {
      try {
        const meId = String(currentUserData?.userId ?? "").trim();
        const memberIds = uniqStrings([
          ...selectedMembers.map((m) => toId(m)),
          meId,
        ]);
        await setGroupMembers(gpId, memberIds, chatToken);
      } catch {
      }

      await getSingleGroupAndProject();
      hide();
    }
  }, [activeChannel?.gpId, selectedMembers, chatToken, currentUserData?.userId, getSingleGroupAndProject, hide]);

  useEffect(() => {
    if (activeChannel?.gpId) getSingleGroupAndProject();
  }, [activeChannel?.gpId, getSingleGroupAndProject]);

  return (
    <Modal show={show} onHide={hide}>
      <Modal.Header closeButton className="p-3">
        <Modal.Title style={{ fontSize: 15 }}>{title || "Add Team Members"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">Team Members</Form.Label>

          <Multiselect
            options={members}
            placeholder="Select team members"
            displayValue="label"
            selectedValues={selectedMembers}
            onSelect={handleChange}
            onRemove={handleChange}
            style={{
              chips: { background: "#0d6efd", fontSize: "12px" },
              searchBox: {
                border: "1px solid #ced4da",
                borderRadius: "6px",
                minHeight: "38px",
                fontSize: "14px",
                padding: "5px",
              },
              option: { fontSize: "14px" },
            }}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer className="p-0">
        <div className="text-end px-2 py-2">
          <Button size="sm" variant="primary" style={{ fontSize: 12 }} onClick={updatedGroupAndProject}>
            Add Members
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddMemberInGroup;

